import React, { Component } from 'react'
import axios from 'axios'
import ReCAPTCHA from "react-google-recaptcha"
// import DatePicker from "react-datepicker";
import { Redirect } from "react-router-dom"
import CreditCard from "./CreditCard"
import "bootstrap/dist/css/bootstrap.min.css"

import "react-datepicker/dist/react-datepicker.css";

const recaptchaRef = React.createRef()
class MemberSignUp extends Component {
  constructor() {
    super()
    this.state = {
      name: "",
      email: "",
      password: "",
      birthday: "",
      confirmEmail: "",
      confirmPassword: "",
      human: false,
      complete: false
    }
    this.changeName = this.changeName.bind(this)
    this.changeEmail = this.changeEmail.bind(this)
    this.changePassword = this.changePassword.bind(this)
    this.changeConfirmPassword = this.changeConfirmPassword.bind(this)
    this.changeConfirmEmail = this.changeConfirmEmail.bind(this)
    this.changeBirthday = this.changeBirthday.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onChange = this.onChange.bind(this)
  }
  changeName(event) {
    this.setState({
      name: event.target.value
    })
  }
  changeBirthday(event) {
    this.setState({
      birthday: event.target.value
    })
  }
  changeEmail(event) {
    this.setState({
      email: event.target.value
    })
  }
  changePassword(event) {
    this.setState({
      password: event.target.value
    })
  }
  changeConfirmPassword(event) {
    this.setState({
      confirmPassword: event.target.value
    })
  }
  changeConfirmEmail(event) {
    this.setState({
      confirmEmail: event.target.value
    })
  }

  onSubmit(event) {
    event.preventDefault()
    const { password, confirmPassword, email, confirmEmail } = this.state;
    if (password !== confirmPassword) {
      alert("Password don't match");
    }
    if (email !== confirmEmail) {
      alert("Emails do not match")
    }
    else
      if (this.state.human === true) {
        const registered = {
          name: this.state.name,
          email: this.state.email,
          password: this.state.password
        }
        console.log(registered)
        axios.post('http://localhost:4000/app/sign-up', registered)
          .then((response) => {
            console.log("RESPONSE", response)
            if (response.data.value === 0) {
              this.setState({ complete: true })
              alert("Thank you for signing up")
            }
            else if (response.data.value === 1) {
              alert("That email is already registered.")
            }
            else {
              alert("Something went wrong - please send me an email at logan@seatstir.com")
            }
          })
      }
      else {
        alert("Please prove you're not a robot")
      }
  }
  onChange(value) {
    const recaptchaValue = recaptchaRef.current.getValue();
    if (value === recaptchaValue) {
      this.setState({
        human: true
      })
    }
  }

  render() {
    if (this.state.complete) {
      return <Redirect to={{ pathname: "/" }} />
    }
    return (
      <div>
        <div id="callMe" className="form-1">
          <div className="container">
            <div className="row" id="signUpTestRow">
              <div className="col-lg-6" id="signUpTestRowA">
                <div className="text-container getInTouchContainer">
                  <div className="section-title">SIGN UP TODAY</div>
                  <h2 className="white">Are you not entertained?!</h2>
                  <p className="white">We list shows and events which our members get to attend free. A typical member is
                  likely to find a new favorite venue participating along the way, along with plenty of places they
                  didn't know about or have yet to visit. A SeatStir membership is your invitation to explore your area!</p>
                  <ul className="list-unstyled li-space-lg white">
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">The Netflix of live entertainment</div>
                    </li>
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">Always have something fun to do</div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-6" id="memberSignUpForm">
                <div className="section-title signupHeaders">Account Information</div>
                <form
                  id="callMeForm"
                  data-toggle="validator"
                  data-focus="false"
                  onSubmit={this.onSubmit}
                >
                  <div className="signUpMain">
                    <div className="signupInputCols">
                      <div className="form-group">
                        <input type="text" className="form-control-input signupInput" id="lname" name="lname" required onChange={this.changeName} value={this.state.name} placeholder="Full Name" />
                      </div>
                      <div className="form-group">
                        <input type="email" className="form-control-input signupInput" id="lemail" name="lemail" required onChange={this.changeEmail} value={this.state.email} placeholder="Email" />
                      </div>
                      <div className="form-group">
                        <input type="password" className="form-control-input signupInput" id="lpassword" name="lpassword" required onChange={this.changePassword} value={this.state.password} placeholder="Password" />
                      </div>
                    </div>
                    <div className="signupInputCols">
                      <div>
                        <div className="form-group">
                          <input type="text" className="form-control-input signupInput" required onChange={this.changeBirthday} value={this.state.birthday} placeholder="Birthday - MM/DD/YYYY" />
                          {/* use <DatePicker /> to select birthday*/}
                        </div>
                        <div className="form-group">
                          <input type="email" className="form-control-input signupInput" required onChange={this.changeConfirmEmail} value={this.state.confirmEmail} placeholder="Confirm Email" />
                        </div>
                        <div className="form-group">
                          <input type="password" className="form-control-input signupInput" id="lconfirmPassword" name="lconfirmPassword" required onChange={this.changeConfirmPassword} value={this.state.confirmPassword} placeholder="Confirm Password" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="signupInputCols">
                      <div>
                        <div className="section-title signupHeaders">Billing Info.</div>
                        <CreditCard />
                        {/* <div className="form-group">
                          <input type="text" className="form-control-input signUpBilling" id="lname" name="lname" required onChange={this.changeName} value={this.state.Name} placeholder="Credit Card Number" />
                        </div>
                        <div className="ccInf">
                          <div className="form-group">
                            <input type="email" className="form-control-input signUpBillingInfo" id="lemail" name="lemail" required onChange={this.changeEmail} value={this.state.email} placeholder="MM" />
                          </div>
                          <div className="form-group">
                            <input type="email" className="form-control-input signUpBillingInfo" id="lemail" name="lemail" required onChange={this.changeEmail} value={this.state.email} placeholder="YY" />
                          </div>
                          <div className="form-group">
                            <input type="email" className="form-control-input signUpBillingInfo" id="lemail" name="lemail" required onChange={this.changeEmail} value={this.state.email} placeholder="CVV" />
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>

                  <div className="form-group checkbox white">
                    <input type="checkbox" id="lterms" value="Agreed-to-Terms" name="lterms" required />I agree
                      with Seatstir's stated <a className="white" href="privacy-policy.html">Privacy Policy</a> and <a
                      className="white" href="terms-conditions.html">Terms & Conditions</a>
                  </div>
                  <div className="form-group" id="memberSubmitContainer">
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                      onChange={this.onChange}
                      theme="dark"
                    />
                    <input type="submit" className="form-control-submit-button" value="Submit" />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default MemberSignUp